/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Subtitle_V2Inputs */

const vi_sidebar_layout_subtitle_v2 = /** @type {(inputs: Sidebar_Layout_Subtitle_V2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kéo-thả để sắp xếp menu, tạo menu cha mới và chuyển menu con vào cha bất kỳ. Menu con chỉ đổi được tên, không xoá hay đổi liên kết. Áp dụng cho toàn bộ người dùng.`)
};

/**

* @param {Sidebar_Layout_Subtitle_V2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_subtitle_v2 = /** @type {((inputs?: Sidebar_Layout_Subtitle_V2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Subtitle_V2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_subtitle_v2(inputs)
});